// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var ViewStack = require("../../../reason/common/ViewStack.bs.js");
var QueryParams = require("../../../reason/QueryParams.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
var PropertyWizardRelay__Types = require("./PropertyWizardRelay__Types.bs.js");
var PropertyWizardRelay__Footer = require("./PropertyWizardRelay__Footer.bs.js");
var PropertyWizardRelay__Header = require("./PropertyWizardRelay__Header.bs.js");
var PropertyWizardRelay__Preview = require("./PropertyWizardRelay__Preview.bs.js");
var PropertyWizardRelayNavigation = require("./PropertyWizardRelayNavigation.bs.js");
var PropertyWizardRelay__KeyFacts = require("./PropertyWizardRelay__KeyFacts.bs.js");
var PropertyWizardRelay__Showings = require("./PropertyWizardRelay__Showings.bs.js");
var PropertyWizardRelay__MLSTiming = require("./PropertyWizardRelay__MLSTiming.bs.js");
var PropertyWizardRelay__SaveDraft = require("./PropertyWizardRelay__SaveDraft.bs.js");
var PropertyWizardFormRelay__Effects = require("./PropertyWizardFormRelay__Effects.bs.js");
var PropertyWizardRelay__Description = require("./PropertyWizardRelay__Description.bs.js");
var PropertyWizardRelay__PhotosAndFiles = require("./PropertyWizardRelay__PhotosAndFiles.bs.js");
var PropertyWizardBodyRelayQuery_graphql = require("../../../__generated__/PropertyWizardBodyRelayQuery_graphql.bs.js");
var PropertyWizardRelay__PriceDropCallout = require("./PropertyWizardRelay__PriceDropCallout.bs.js");
var PropertyWizardRelay__RebroadcastWarning = require("./PropertyWizardRelay__RebroadcastWarning.bs.js");
var PropertyWizardRelay__BroadcastQuietSellerWarning = require("./PropertyWizardRelay__BroadcastQuietSellerWarning.bs.js");

function encode(param) {
  return Core__Option.map(param, PropertyWizardRelay__Types.Key.toJs);
}

function decode(string) {
  return Core__Option.flatMap(string, PropertyWizardRelay__Types.Key.fromJs);
}

var StepParam = {
  encode: encode,
  decode: decode
};

function encode$1(param) {
  return Core__Option.map(param, (function (param) {
                return param;
              }));
}

function decode$1(string) {
  return Core__Option.map(string, (function (string) {
                switch (string) {
                  case "dismissed" :
                      return "dismissed";
                  case "shown" :
                      return "shown";
                  default:
                    return "NotShown";
                }
              }));
}

var PriceDropInfo = {
  encode: encode$1,
  decode: decode$1
};

function boolWithDefault($$default) {
  return QueryParams.UseQueryParams.ParamConfigs.fromParamConfig(QueryParams.ParamConfigs.withHiddenDefault(QueryParams.ParamConfigs.booleanParam, $$default));
}

function stepWithDefault($$default) {
  return QueryParams.UseQueryParams.ParamConfigs.fromParamConfig(QueryParams.ParamConfigs.withHiddenDefault(StepParam, $$default));
}

function priceDropWithDefault($$default) {
  return QueryParams.UseQueryParams.ParamConfigs.fromParamConfig(QueryParams.ParamConfigs.withHiddenDefault(PriceDropInfo, $$default));
}

var config = Object.fromEntries([
      [
        "previewing",
        boolWithDefault(false)
      ],
      [
        "step",
        stepWithDefault("keyFacts")
      ],
      [
        "priceDropInfo",
        priceDropWithDefault("NotShown")
      ]
    ]);

var ParamsConfig = {
  StepParam: StepParam,
  PriceDropInfo: PriceDropInfo,
  boolWithDefault: boolWithDefault,
  stepWithDefault: stepWithDefault,
  priceDropWithDefault: priceDropWithDefault,
  config: config
};

var UseQueryParams = QueryParams.UseQueryParams.Make({
      config: config
    });

var use = UseQueryParams.use;

var QueryParams$1 = {
  Key: undefined,
  ParamsConfig: ParamsConfig,
  UseQueryParams: UseQueryParams,
  use: use
};

var convertVariables = PropertyWizardBodyRelayQuery_graphql.Internal.convertVariables;

var convertResponse = PropertyWizardBodyRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = PropertyWizardBodyRelayQuery_graphql.Internal.convertWrapRawResponse;

var use$1 = RescriptRelay_Query.useQuery(convertVariables, PropertyWizardBodyRelayQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, PropertyWizardBodyRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(PropertyWizardBodyRelayQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(PropertyWizardBodyRelayQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(PropertyWizardBodyRelayQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(PropertyWizardBodyRelayQuery_graphql.node, convertVariables);

var LocalDraftPropertyQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$1,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function PropertyWizardBodyRelay(props) {
  var match = PropertyWizardFormRelay.Context.use();
  var mode = match.mode;
  var match$1 = use();
  var queryParams = match$1[0];
  var activeStep = queryParams.step;
  var setQueryParams = match$1[1];
  var data = use$1(undefined, "store-only", undefined, undefined);
  var goToStep = function (step) {
    setQueryParams(undefined, {
          previewing: queryParams.previewing,
          step: step,
          priceDropInfo: queryParams.priceDropInfo
        });
  };
  var match$2 = React.useState(function () {
        
      });
  PropertyWizardFormRelay__Effects.use(data.localDraft.fragmentRefs, data.localDraftFormState.fragmentRefs, match$2[1]);
  if (queryParams.previewing) {
    return JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(PropertyWizardRelay__Preview.make, {
                      draft: data.localDraft.fragmentRefs,
                      formState: data.localDraftFormState.fragmentRefs,
                      onEditForm: (function (step) {
                          setQueryParams(undefined, {
                                previewing: false,
                                step: step,
                                priceDropInfo: queryParams.priceDropInfo
                              });
                        }),
                      currentStep: activeStep
                    }),
                className: "flex-1 bg-white"
              });
  }
  var tmp;
  if (typeof mode !== "object") {
    tmp = null;
  } else {
    switch (mode.TAG) {
      case "Edit" :
          tmp = "Click directly on the step you wish to edit below";
          break;
      case "Rebroadcast" :
          var policy = mode._1.broadcastPolicy;
          var exit = 0;
          switch (queryParams.priceDropInfo) {
            case "shown" :
                switch (policy.__typename) {
                  case "PropertyBroadcastAllowed" :
                      if (policy.priceCondition !== undefined) {
                        tmp = JsxRuntime.jsx(PropertyWizardRelay__PriceDropCallout.make, {
                              onDismiss: (function () {
                                  setQueryParams("replaceIn", {
                                        previewing: queryParams.previewing,
                                        step: queryParams.step,
                                        priceDropInfo: "dismissed"
                                      });
                                })
                            });
                      } else {
                        exit = 1;
                      }
                      break;
                  case "PropertyBroadcastNotAllowed" :
                  case "__unselected" :
                      exit = 1;
                      break;
                  
                }
                break;
            case "dismissed" :
                switch (policy.__typename) {
                  case "PropertyBroadcastAllowed" :
                      if (policy.priceCondition !== undefined) {
                        tmp = null;
                      } else {
                        exit = 1;
                      }
                      break;
                  case "PropertyBroadcastNotAllowed" :
                  case "__unselected" :
                      exit = 1;
                      break;
                  
                }
                break;
            case "NotShown" :
                exit = 1;
                break;
            
          }
          if (exit === 1) {
            tmp = JsxRuntime.jsx(PropertyWizardRelay__RebroadcastWarning.make, {
                  policy: policy,
                  draft: data.localDraft.fragmentRefs
                });
          }
          break;
      case "BroadcastQuietSeller" :
          tmp = JsxRuntime.jsx(PropertyWizardRelay__BroadcastQuietSellerWarning.make, {
                privacy: mode._1.privacySetting
              });
          break;
      
    }
  }
  return JsxRuntime.jsxs(MarkupHelpers.Container.make, {
              className: "flex-1 my-10",
              children: [
                JsxRuntime.jsxs(FormV5.FormSection.make, {
                      children: [
                        JsxRuntime.jsx(PropertyWizardRelay__Header.make, {
                              draft: data.localDraft.fragmentRefs
                            }),
                        JsxRuntime.jsxs(ViewStack.make, {
                              alignItems: "stretch",
                              flexDirection: "column",
                              children: [
                                tmp,
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(PropertyWizardRelay__SaveDraft.SaveDraftIndicator.make, {
                                            formState: data.localDraftFormState.fragmentRefs,
                                            localDraft: data.localDraft.fragmentRefs
                                          })
                                    })
                              ]
                            })
                      ]
                    }),
                JsxRuntime.jsx(FormV5.FormSection.make, {
                      children: JsxRuntime.jsx(PropertyWizardRelayNavigation.make, {
                            draft: data.localDraft.fragmentRefs,
                            formState: data.localDraftFormState.fragmentRefs,
                            selectStep: goToStep,
                            activeStep: activeStep
                          })
                    }),
                activeStep === "description" ? JsxRuntime.jsx(PropertyWizardRelay__Description.make, {
                        draft: data.localDraft.fragmentRefs,
                        formState: data.localDraftFormState.fragmentRefs
                      }) : (
                    activeStep === "mlsTiming" ? JsxRuntime.jsx(PropertyWizardRelay__MLSTiming.make, {
                            draft: data.localDraft.fragmentRefs,
                            formState: data.localDraftFormState.fragmentRefs
                          }) : (
                        activeStep === "photosAndFiles" ? JsxRuntime.jsx(PropertyWizardRelay__PhotosAndFiles.make, {
                                draft: data.localDraft.fragmentRefs
                              }) : (
                            activeStep === "keyFacts" ? JsxRuntime.jsx(PropertyWizardRelay__KeyFacts.make, {
                                    draft: data.localDraft.fragmentRefs,
                                    formState: data.localDraftFormState.fragmentRefs,
                                    duplicatedProperty: match$2[0]
                                  }) : JsxRuntime.jsx(PropertyWizardRelay__Showings.make, {
                                    draft: data.localDraft.fragmentRefs
                                  })
                          )
                      )
                  ),
                JsxRuntime.jsx(FormV5.FormSection.make, {
                      children: JsxRuntime.jsx(PropertyWizardRelay__Footer.make, {
                            step: queryParams.step,
                            goToPreview: (function () {
                                setQueryParams(undefined, {
                                      previewing: true,
                                      step: queryParams.step,
                                      priceDropInfo: queryParams.priceDropInfo
                                    });
                              }),
                            goToStep: goToStep,
                            draft: data.localDraft.fragmentRefs
                          })
                    })
              ]
            });
}

var FormSection;

var SaveDraftIndicator;

var KeyFacts;

var Description;

var MLSTiming;

var Showings;

var PhotosAndFiles;

var Validators;

var FormEffects;

var Preview;

var Header;

var Footer;

var make = PropertyWizardBodyRelay;

exports.FormSection = FormSection;
exports.SaveDraftIndicator = SaveDraftIndicator;
exports.QueryParams = QueryParams$1;
exports.LocalDraftPropertyQuery = LocalDraftPropertyQuery;
exports.KeyFacts = KeyFacts;
exports.Description = Description;
exports.MLSTiming = MLSTiming;
exports.Showings = Showings;
exports.PhotosAndFiles = PhotosAndFiles;
exports.Validators = Validators;
exports.FormEffects = FormEffects;
exports.Preview = Preview;
exports.Header = Header;
exports.Footer = Footer;
exports.make = make;
/* config Not a pure module */
